@if (show) {
  @if (isEditable) {
    <div class="ag-input-wrapper inner-icon right-icon">
      <i class="far fa-calendar fa-sm text-blue" (click)="datePicker.toggle()"></i>
      <input
        class="form-control border-0 bg-transparent text-blue"
        ngbDatepicker
        #datePicker="ngbDatepicker"
        [value]="params.value"
        (click)="datePicker.toggle()"
        (change)="onDateChanged($event.target.value)"
        (dateSelect)="onDatePicked($event)"
      />
    </div>
  }
  @if (!isEditable) {
    <div>{{ params.value }}</div>
  }
}
